export default __webpack_public_path__ + "0a58e56dff59be39beacaf961ab06119.png";